<template>
  <div v-if="profile">
    <Card shadow :padding="10" class="add-margin" v-if="profile.about_me && showField('about_me')">
      <p class="section-header">About Me</p>
      <Row>
        <i-col :span="24">{{profile.about_me}}</i-col>
      </Row>
    </Card>
    <Card shadow :padding="10" class="add-margin">
      <p class="section-header">Details</p>
      <Row>
        <i-col v-if="showField('first_name')" :span="8" class="section-label">First Name</i-col>
        <i-col v-if="showField('first_name')" :span="16"><span class="section-value">{{profile.first_name || 'Not Specified'}}</span></i-col>
        <i-col v-if="showField('last_name')" :span="8" class="section-label">Last Name</i-col>
        <i-col v-if="showField('last_name')" :span="16"><span class="section-value">{{profile.last_name || 'Not Specified'}}</span></i-col>
        <i-col v-if="showField('gender')" :span="8" class="section-label">Gender</i-col>
        <i-col v-if="showField('gender')" :span="16"><span class="section-value">{{profile.gender || 'Not Specified'}}</span></i-col>
        <i-col v-if="showField('age_bracket')" :span="8" class="section-label">Age</i-col>
        <i-col v-if="showField('age_bracket')" :span="16"><span class="section-value">{{profile.age_bracket || 'Not Specified'}}</span></i-col>
        <i-col v-if="showField('employment_status')" :span="8" class="section-label">Employment Status</i-col>
        <i-col v-if="showField('employment_status')" :span="16"><span class="section-value">{{profile.employment_status || 'Not Specified'}}</span></i-col>
      </Row>
    </Card>
    <Card shadow :padding="10" class="add-margin">
      <p class="section-header">Location</p>
      <Row>
        <i-col v-if="showField('country')" :span="8" class="section-label">Country</i-col>
        <i-col v-if="showField('country')" :span="16"><span class="section-value">{{profile.country || 'Not Specified'}}</span></i-col>
        <i-col v-if="showField('region')" :span="8" class="section-label">Regions</i-col>
        <i-col v-if="showField('region')" :span="16"><span class="section-value">{{profile.region || 'Not Specified'}}</span></i-col>
        <i-col v-if="showField('province')" :span="8" class="section-label">Province</i-col>
        <i-col v-if="showField('province')" :span="16"><span class="section-value">{{profile.province || 'Not Specified'}}</span></i-col>
        <i-col v-if="showField('city')" :span="8" class="section-label">City</i-col>
        <i-col v-if="showField('city')" :span="16"><span class="section-value">{{profile.city || 'Not Specified'}}</span></i-col>
        <i-col v-if="showField('zipcode')" :span="8" class="section-label">Zip Code</i-col>
        <i-col v-if="showField('zipcode')" :span="16"><span class="section-value">{{profile.zipcode || 'Not Specified'}}</span></i-col>
      </Row>
    </Card>
    <Card shadow :padding="10" class="add-margin" v-show="showField('email') || showField('contact_number')">
      <p class="section-header">Contact Info</p>
      <Row>
        <i-col v-if="showField('contact_number')" :span="8" class="section-label">Contact Number</i-col>
        <i-col v-if="showField('contact_number')" :span="16"><span class="section-value">{{profile.contact_number}}</span></i-col>
        <i-col v-if="showField('email')" :span="8" class="section-label">Email Address</i-col>
        <i-col v-if="showField('email')" :span="16"><span class="section-value">{{profile.email || 'Not Specified'}}</span></i-col>
      </Row>
    </Card>
  </div>
</template>

<script>
export default {
  props: {
    profile: {
      required: true,
      type: Object
    }
  },
  methods :{
    showField(slug) {
      if( this.visibleFields.indexOf(slug) > -1 )
        return true
      return false;
    }
  },
  computed: {
    visibleFields: {
      get() {
        return this.profile.visible_fields || this.defaults
      }
    }
  },
  data() {
    return {
      defaults: ['first_name', 'last_name', 'province', 'city', 'country', 'about_me']
    }
  }
}
</script>

<style scoped>
  .add-margin {
    margin-bottom:5px;
  }
  .section-header {
    font-weight: 700;
    color:#aaa;
  }
  .section-label {
    font-size:11px;
    line-height: 20px;
    color:#aaa;
  }
  .section-value {
    min-height: 20px;
    display: block;
  }
</style>
